import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import {
  mockGetLatestOperations,
  mockGetOperationsBefore,
  mockListPool,
} from "./FollowPoolMock";
import type {
  FollowPoolOperationRow,
  FollowPoolOperationsPageResult,
  FollowPoolOperationsQuery,
  FollowPoolPositionRow,
} from "./FollowPoolType";

const mockFollowPool = useLongfansMock && false;

const BASE = "/lark/app/followPool";

function formatDateApi(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const h = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  const s = String(d.getSeconds()).padStart(2, "0");
  return `${y}-${m}-${day} ${h}:${min}:${s}`;
}

/** 后端游标用 yyyy-MM-dd HH:mm:ss；axios 可能把结果转成 Date */
export function followPoolOperationCursorTime(row: FollowPoolOperationRow): string {
  const v = row.createdAt as unknown;
  if (v instanceof Date) {
    return formatDateApi(v);
  }
  if (typeof v === "string") {
    return v.trim();
  }
  return "";
}

export const FollowPoolApi = {
  async listPool(spaceId: string, spaceProductId: string): Promise<FollowPoolPositionRow[] | null> {
    if (mockFollowPool) {
      return mockListPool(spaceProductId);
    }
    const r = await post<
      { spaceId: string; spaceProductId: string },
      FollowPoolPositionRow[]
    >(`${BASE}/listPool`, { spaceId, spaceProductId }, { silent: true });
    return typeof r === "string" ? null : r;
  },

  async getLatestOperations(
    spaceId: string,
    spaceProductId: string,
    query?: FollowPoolOperationsQuery
  ): Promise<FollowPoolOperationsPageResult | null> {
    if (mockFollowPool) {
      return mockGetLatestOperations(spaceProductId, query);
    }
    const r = await post<
      {
        spaceId: string;
        spaceProductId: string;
        pageSize?: number;
        stockCode?: string;
      },
      FollowPoolOperationsPageResult
    >(
      `${BASE}/getLatestOperations`,
      {
        spaceId,
        spaceProductId,
        pageSize: query?.pageSize,
        stockCode: query?.stockCode?.trim() || undefined,
      },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },

  async getOperationsBefore(
    spaceId: string,
    spaceProductId: string,
    cursor: { createdAt: string; id: string },
    query?: FollowPoolOperationsQuery
  ): Promise<FollowPoolOperationsPageResult | null> {
    if (mockFollowPool) {
      return mockGetOperationsBefore(spaceProductId, cursor, query);
    }
    const r = await post<
      {
        spaceId: string;
        spaceProductId: string;
        pageSize?: number;
        stockCode?: string;
        cursorBeforeCreatedAt: string;
        cursorBeforeId: string;
      },
      FollowPoolOperationsPageResult
    >(
      `${BASE}/getOperationsBefore`,
      {
        spaceId,
        spaceProductId,
        pageSize: query?.pageSize,
        stockCode: query?.stockCode?.trim() || undefined,
        cursorBeforeCreatedAt: cursor.createdAt,
        cursorBeforeId: cursor.id,
      },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },
};
